<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title"
                    v-t="{ path: 'message.title_delete_object', args: { objectName: this.deleteObjectTitle } }">
                </div>
                <hr class="dialog-hr" />
                <div class="confirm-body" v-html="$t('message.info_delete_object', { objectName: this.deleteObjectName })">
                </div>
                <hr class="dialog-hr" />
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')"
                        v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="$emit('delete')">OK</el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        confirmInfo: Object,
    },

    data() {
        return {
            deleteObjectTitle: null,
            deleteObjectName: null
        };
    },

    created() {
        this.deleteObjectTitle = this.confirmInfo.objectTitle;
        this.deleteObjectName = this.confirmInfo.objectName;
    }
};
</script>

<style scoped></style>
